import React, { type JSX } from 'react';
import PaymentMethods from '../../visuals/Icons/Old/PaymentMethods';

interface ISummary {
  children: React.ReactNode;
  UNSAFE_className?: string;
}

export const Summary = ({ children, UNSAFE_className }: ISummary) => {
  return (
    <div
      className={`${UNSAFE_className || ''}
      tw-w-full tw-max-w-[384px] tw-rounded-2xl
      tw-border tw-border-solid tw-border-blue-200 tw-p-4 desktop:tw-p-6
    `}
    >
      {React.Children.map(children, (child, index) => (
        <>
          {index > 0 && children?.[index - 1]?.props?.children && (
            <hr className="tw-border-0 tw-border-b tw-border-solid tw-border-blue-200" />
          )}
          {child}
        </>
      ))}
    </div>
  );
};

interface ILineWithValue {
  isImportant?: boolean;
  label: string | JSX.Element;
  value: string | JSX.Element;
  UNSAFE_className?: string;
}

export const LineWithValue = ({
  label,
  value,
  isImportant,
  UNSAFE_className,
}: ILineWithValue) => (
  <div
    className={`${UNSAFE_className || ''}
    tw-flex tw-justify-between [&>*]:tw-max-w-[70%]
    ${isImportant ? 'tw-font-title tw-text-lg tw-font-black' : ''}
  `}
  >
    <div>{label}</div>
    <b className="tw-font-semibold">{value}</b>
  </div>
);

export const HighlightedValue = ({
  children,
}: {
  children: React.ReactNode;
}) => (
  <div className="highlighted-value tw-font-semibold tw-text-blue-600">
    {children}
  </div>
);

export const SecuredPayment = ({ label }: { label: string }) => (
  <div className="secured-payment tw-mx-0 tw-my-2 tw-flex tw-flex-col tw-items-center tw-justify-center [&>svg]:tw-mb-3">
    <PaymentMethods aria-hidden="true" />
    <span>{label}</span>
  </div>
);
